import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getRelateFeedList, getRecommendInfo } from '@src/services/api';
import { formatImage } from '@ifeng-fe/public_method';
import styles from './index.css';
import FeedList from './feedList';

const Recommend = ({ content }) => {
    const [data, setData] = useState([]);
    const formatRelateData = (data) => {
        let result = [];

        if (!data || data.length === 0) {
            return result;
        }
        result = data.map((item) => {
            return {
                base62Id: item.base62Id,
                count: {},
                createtime: item.newsTime,
                pcUrl: item.url,
                url: item.url,
                title: item.title || '',
                source: item.source || '',
                sourceFrom: item.type || '',
                thumbnailpic: (item.thumbnails && item.thumbnails.image && item.thumbnails.image[0] && item.thumbnails.image[0].url && formatImage(item.thumbnails.image[0].url, 140, 80)) || '',
            };
        });

        return result;
    };
    const arrayPropertyUnique = (arr = [], uniId = '') => {
        const obj = {};
        const tempArr = [];

        for (let i = 0; i < arr.length; i++) {
            if (!obj[arr[i][uniId]]) {
                tempArr.push(arr[i]);
                if (arr[i][uniId]) {
                    obj[arr[i][uniId]] = true;
                }
            }
        }

        return tempArr;
    };

    const getRecommendData = async () => {
        try {
            let relateData = [];

            if (content.relatedRecommend.length > 0) {
                relateData = await getRelateFeedList(content.relatedRecommendrelatedRecommend);
            }
            const recommendData = await getRecommendInfo();
            let resultData = [];

            relateData = formatRelateData(relateData);

            if (content.isHitBlack || content.isCloseAlgRec) {
                resultData = relateData;
            } else {
                resultData = relateData.concat(recommendData);
            }

            resultData = arrayPropertyUnique(resultData, 'base62Id');

            if (resultData && resultData.length > 0) {
                setData(resultData);
            }
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        getRecommendData();
    }, []);

    const feedList = {
        data,
        base62Id: content.base62Id,
        ad: content.ad,
    };

    return (
        <div className={styles.recommend}>
            <div className={styles.recommendTitle}>为您推荐</div>
            {data.length > 0 ? <FeedList content={feedList} /> : null}
        </div>
    );
};

Recommend.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Recommend);
